// extracted by mini-css-extract-plugin
export default {"root":"styles_root__E-B2o","info":"styles_info__b3zET","leftPanel":"styles_leftPanel__BRdwx","container":"styles_container__gs5eC"};